import { z } from "zod";

import { TAny } from "@/interfaces/globals";
import { RecoveryPathway } from "@/interfaces/wastetype.interface";
import { basicValidator } from "@/lib/validators";

export const WasteType = z.object({
  id: z.string().optional(),
  name: basicValidator(true, "Waste Name is required", 2, 50),
  recyclingPercentage: z.coerce.number().nonnegative().max(100).default(0),
  recoveryPathway: z.enum(Object.values(RecoveryPathway) as TAny, {
    message: "Recovery pathway is required",
  }),
});

export type TWasteType = z.infer<typeof WasteType>;
